import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import images from '../images';
import CreateNewFlowModal from '../components/Modals/CreateNewFlowModal';
import ReplenishBalanceModal from '../components/Modals/ReplenishBalanceModal';
import FlowCard from '../components/Cards/FlowCard';
import {getUserData} from '../api/userData';
import {apiRequest} from "../api";
import DefaultLayout from '../components/DefaultLayout';

const Flows = () => {
  const { id } = useParams();
  const [showCreateNewFlowModal, setShowCreateNewFlowModal] = useState(false);
  const [showReplenishBalanceModal, setShowReplenishBalanceModal] = useState(false);

  const [flows, setFlows] = useState([]);
  // const [userData, setUserData] = useState(null);
  // const [operations, setOperations] = useState([]);
  // const [leads, setLeads] = useState([]);
  const [loading, setLoading] = useState(true);

  const closeCreateNewFlowModal = () => {
    setShowCreateNewFlowModal(false);
  };

  const refreshFlows = async () => {
    try {
      setLoading(true);
      const flowsData = await getUserData(id);
      const userFlows = flowsData?.flows;
      setFlows(userFlows);
    } catch (error) {
      console.error('Ошибка при обновлении потоков:', error);
    } finally {
      setLoading(false);
    }
  };

  const closeReplenishBalanceModal = () => {
    setShowReplenishBalanceModal(false);
  };

  // Загрузка потоков пользователя при монтировании компонента
  useEffect(() => {
    let isMounted = true;
    
    const loadFlows = async () => {
      try {
        setLoading(true);
        // const advertiserData = await apiRequest(`users/${id}/profile`, 'GET');
        // if (!isMounted) return;
        //
        // // console.log("userData: ", userData);
        // const operationsData = await apiRequest(`/invoice/list?rekl_id=${id}`, 'GET')
        // // console.log("operationsData: ", operationsData);
        // const leadsData = await apiRequest(`/leads/${id}/list`, 'GET')
        // Проверяем, что компонент все еще смонтирован перед продолжением
        const flowsData = await getUserData(id)
        // Получаем потоки пользователя по его ID
        const userFlows = flowsData?.flows;
        // console.log("userFlows: ", userFlows);
        
        // Проверяем, что компонент все еще смонтирован перед обновлением состояния
        // setUserData(advertiserData.data || advertiserData);
        // setOperations(operationsData.data)
        setFlows(userFlows);
        // setLeads(leadsData.data)
      } catch (error) {
        // Проверяем, что компонент все еще смонтирован перед обновлением состояния
        if (isMounted) {
          console.error('Ошибка при загрузке потоков:', error);
        }
      } finally {
        // Проверяем, что компонент все еще смонтирован перед обновлением состояния
        if (isMounted) {
          setLoading(false);
        }
      }
    };
    
    loadFlows();
    
    // Очистка при размонтировании компонента
    return () => {
      isMounted = false;
    };
  }, []);
  console.log("flows: ", flows);
  return (
    <DefaultLayout>
      <div className="my-flows-main">
        {/* Нижний блок */}
        <div className="my-flows-lower-block">
          {flows.length === 0 ? (
                  <div className="no-flows-placeholder">
                      <img
                        src={images.winrarOutlineBig}
                        alt="Пусто"
                      />
                      <p>Тут пока ничего нет : (</p>
                  </div>
            ) : (
              <>
                <div className="my-flows-lower-header">

                  <img
                      src={images.winrarOutline}
                      alt="Пусто"
                      style={{marginRight: '7px'}}
                  />

                  <h2 className="my-flows-lower-title">Потоки рекламодателя</h2>
                </div>
                <div className="my-flows-lower-content">
                  {loading ? (
                          <div>Загрузка потоков...</div>
                      ) :
                      (
                          flows.map(flow => (
                              <FlowCard key={flow.id} flow={flow} refreshFlows={refreshFlows} userId={id}/>
                          ))
                      )}
                </div>
              </>
          )}
        </div>

        {showCreateNewFlowModal && (
            <CreateNewFlowModal
                isOpen={showCreateNewFlowModal}
                onClose={closeCreateNewFlowModal}
                refreshFlows={refreshFlows}
            />
        )}

        {showReplenishBalanceModal && (
            <ReplenishBalanceModal
                isOpen={showReplenishBalanceModal}
                onClose={closeReplenishBalanceModal}
            />
        )}

      </div>
    </DefaultLayout>
  );
};

export default Flows;